export default __webpack_public_path__ + "static/media/4_home-image.6f7cd76a.jpg";